import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Productos_db from '../../database/productos_db.json';
import styles from './ProductoDetalle.module.css';
import ProductCard from '../../components/ProductCard/ProductCard';

const ProductoDetalle = () => {
  const { categoria } = useParams();
  const [productosFiltrados, setProductosFiltrados] = useState([]);
  const [categoriaData, setCategoriaData] = useState(null);

  useEffect(() => {
    const categoriaEncontrada = Productos_db.find(
      (item) => item.ruta.split('/').pop() === categoria
    );

    // 👇 AQUÍ ESTABA EL ERROR. Se corrigió "categoriaEnconfrada" por "categoriaEncontrada"
    if (categoriaEncontrada) {
      setCategoriaData(categoriaEncontrada);
      if (Array.isArray(categoriaEncontrada.productos)) {
        setProductosFiltrados(categoriaEncontrada.productos);
      } else {
        setProductosFiltrados([]);
      }
    } else {
      setProductosFiltrados([]);
      setCategoriaData(null);
    }
  }, [categoria]);

  if (productosFiltrados.length === 0 && !categoriaData) {
    return <p>Cargando productos o categoría no encontrada...</p>;
  }

  return (
    <div className={styles.productosDetalladosContainer}>
      {categoriaData && (
        <Helmet>
          <title>• {categoriaData.franja.titulo} — Microled Argentina 🔴</title>
          <meta name="description" content={`Pantallas LED ${categoriaData.franja.titulo.toLowerCase()} — Fabricadas por Microled Argentina. Más de 30 años de experiencia.`} />
          <link rel="canonical" href={`https://microled.com.ar/productos/${categoria}`} />
        </Helmet>
      )}
      {/* Banner de Franja */}
      {categoriaData && (
        <div 
          className={styles.pdfranja} 
          style={{
            backgroundImage: `url('${categoriaData.franja.url[0]}')`,
            backgroundPosition: categoriaData["background-position"] || "center",
          }}
        >
          <h2 className={styles.pdh2}>{categoriaData.franja.titulo}</h2>
        </div>
      )}

      {/* Breadcrumb */}
      {categoriaData && categoriaData.breadcrumb && (
        <nav aria-label="breadcrumb" className={styles.breadcrumbNav}>
          <ol className={styles.breadcrumbList}>
            {categoriaData.breadcrumb.map((item, index) => (
              <li key={index} className={styles.breadcrumbItem}>
                {index < categoriaData.breadcrumb.length - 1 ? (
                  <>
                    <Link to={item.url} className={styles.breadcrumbLink}>{item.name}</Link>
                    <span className={styles.breadcrumbSeparator}> / </span>
                  </>
                ) : (
                  <span className={styles.breadcrumbCurrent}>{item.name}</span>
                )}
              </li>
            ))}
          </ol>
        </nav>
      )}
      
      {/* Listado de ProductCards */}
      {productosFiltrados.length > 0 ? (
        <div className={styles.cardGrid}>
          {productosFiltrados.map((producto) => (
            <ProductCard key={producto.id_producto} producto={producto} />
          ))}
        </div>
      ) : (
        <p>No hay productos disponibles en esta categoría.</p>
      )}
    </div>
  );
};

export default ProductoDetalle;